import React from 'react';
import styled from 'styled-components';
import logo from '../assets/logo.svg';

const HeaderContainer = styled.header`
  background-color: #ffffff;
  padding: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Logo = styled.img`
  height: 40px;
`;

const Header = () => {
  return (
    <HeaderContainer>
      <Logo src={logo} alt="Linx OpenHouse" />
    </HeaderContainer>
  );
};

export default Header;
